export const GET_MENU_USER_COMPANY = "GET_MENU_USER_COMPANY";

